<ng-container *ngIf="singleLogin" #singleLogin>
  <!--link rel="icon" type="image/vnd.microsoft.icon" href="/assets/nmvs/images/favicon.ico"-->
  <div class="container">
    <form class="top-buffer" [formGroup]="userCredentialForm" novalidate
      (ngSubmit)="userLogin(userCredentialForm.value, userCredentialForm.valid)">

      <div class="mb-3 row offset-sm-1">
        <div class="col-sm-3 loginLogo">
        </div>
        <div class="col-sm-4" style="padding-top: 15px; color: var(--consumerBackgroundColor)">
          <h3 class="text-center LanguageLogin">
            {{appName}}
          </h3>
        </div>
      </div>

      <div class="mb-3 row offset-sm-2">
        <div *ngIf="showErrorMessage" class="col-sm-6 alert alert-danger" role="alert">
          {{errorMessage}}
        </div>
      </div>

       <div class="mb-3 row offset-sm-2">
        <label for="inputEmailLogin" class="col-sm-2 col-form-label LanguageLogin">E-Mail/Login</label>
        <div class="col-sm-4">
          <input type="text" id="inputEmailLogin" class="form-control" formControlName="login" #cosyLogin (change)="onCredentialChange(cosyLogin.value)">
          <small
          [hidden]="userCredentialForm.controls.login.valid || (userCredentialForm.controls.login.pristine && !submitted)"
          class="text-danger">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" class="bi bi-exclamation-triangle-fill flex-shrink-0 me-2" viewBox="0 0 16 16" role="img" aria-label="Warning:">
            <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>
          </svg>
          Name is required.
        </small>
        </div>
      </div>
      <div class="mb-3 row offset-sm-2">
        <label for="inputPassword" class="col-sm-2 col-form-label LanguageLogin">Password</label>
        <div class="col-sm-4">
          <input type="password" id="inputPassword" class="form-control" formControlName="password" #cosyPassword>
          <small
            [hidden]="userCredentialForm.controls.password.valid || (userCredentialForm.controls.password.pristine && !submitted)"
            class="text-danger">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" class="bi bi-exclamation-triangle-fill flex-shrink-0 me-2" viewBox="0 0 16 16" role="img" aria-label="Warning:">
              <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>
            </svg>
            Password is required.
          </small>
        </div>
      </div>
      <div class="mb-3 row">
        <div class="offset-sm-5 col-sm-2">
          <input type="hidden" id="appID" class="form-control" formControlName="appID"
            value="a521a42c-c356-4e23-99b0-8ae55a246b56">
          <input type="hidden" id="managedAppID" class="form-control" formControlName="managedAppID"
            value="3879565F-35CC-47E2-B943-BFC6724703AD">
          <button type="submit" class="btn btn-secondary form-control" aria-pressed="true"
            [disabled]="!userCredentialForm.valid">anmelden</button>
        </div>
      </div>
    </form>
  </div>
</ng-container>
<ng-container *ngIf="!singleLogin && (responseToken == null || responseToken.errorCode != 1)">
  <div class="container">
    <form [formGroup]="userCredentialForm" novalidate
      (ngSubmit)="userLogin(userCredentialForm.value, userCredentialForm.valid)">
      <div class="row">
        <div *ngIf="showErrorMessage" class="col-sm-9 alert alert-danger" role="alert">
          {{errorMessage}}
        </div>
      </div>

      <div class="row offset-sm-1 mt-2">
        <label for="inputEmailLogin" class="col-sm-1  col-form-label LanguageLogin" >Login</label>
        <div class="col-sm-3">
          <input type="text" id="inputEmailLogin" class="form-control" formControlName="login"  #cosyLogin  (change)="onCredentialChange(cosyLogin.value)">
          <small
            [hidden]="userCredentialForm.controls.login.valid || (userCredentialForm.controls.login.pristine && !submitted)"
            class="text-white">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" class="bi bi-exclamation-triangle-fill flex-shrink-0 me-2" viewBox="0 0 16 16" role="img" aria-label="Warning:">
              <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>
            </svg>
            Name is required.
          </small>
        </div>
        <label for="inputPassword" class="col-sm-1 col-form-label LanguageLogin">Passwort</label>
        <div class="col-sm-3">
          <input type="password" id="inputPassword" class="form-control" formControlName="password" #cosyPassword>
          <small
            [hidden]="userCredentialForm.controls.password.valid || (userCredentialForm.controls.password.pristine && !submitted)"
            class="text-white">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" class="bi bi-exclamation-triangle-fill flex-shrink-0 me-2" viewBox="0 0 16 16" role="img" aria-label="Warning:">
              <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>
            </svg>
            Password is required.
          </small>
        </div>
        <div class="col-sm-1">
          <input type="hidden" id="autoAuthorize" class="form-control" formControlName="autoAuthorize" value="false">
          <button type="submit" class="btn btn-secondary form-control" aria-pressed="true"
            [disabled]="(isLoginAutofilled && isPasswordAutofilled)? false: (!userCredentialForm.valid)">go</button>
        </div>
      </div>

    </form>
  </div>
</ng-container>
<ng-container *ngIf="!singleLogin && responseToken != null && responseToken.errorCode == 1">
  <div class="container">
    <form class="top-buffer" [formGroup]="userCredentialForm" novalidate (ngSubmit)="userLogOut()">

      <div class="row offset-sm-1 mt-2">
        <div class="col-sm-2 offset-sm-8">
          <button type="submit" class="btn btn-secondary form-control"
            aria-pressed="true">logout</button>
        </div>
      </div>

    </form>
  </div>
</ng-container>